<div style="margin: -25px -25px -25px -15px">
  <nz-layout>
    <div class="livemap-container">
      <div id="livemap" style="height: 88vh"></div>
      <div
        class="filters"
        [ngStyle]="{ 'border-radius': sidebarcollapsed ? '50%' : '' }"
      >
        <div
          [ngStyle]="{
            'box-shadow': sidebarcollapsed
              ? ''
              : '-4px 0px 5px 0 rgba(193, 193, 193, 0.78)',
            background: sidebarcollapsed ? 'transparent' : ''
          }"
        >
          <h2 [ngStyle]="{ display: sidebarcollapsed ? 'none' : 'block' }">
            APSFL Network
          </h2>
          <button
            class="toggle-btn"
            style="margin-left: auto"
            (click)="toggle()"
          >
            <span
              nz-icon
              [nzType]="sidebarcollapsed ? 'filter' : 'close'"
              nzTheme="outline"
              [ngStyle]="{ 'font-size': sidebarcollapsed ? '30px' : '20px' }"
            ></span>
          </button>
        </div>
        <div
          class="sidebar-filters"
          [ngStyle]="{ display: sidebarcollapsed ? 'none' : 'block' }"
        >
          <div class="sidebar-container">
            <form nz-form [formGroup]="form">
              <!-- District Dropdown -->
              <nz-form-item>
                <nz-form-label [nzSpan]="5" nzFor="district"
                  >District</nz-form-label
                >
                <nz-form-control [nzSpan]="18">
                  <nz-select
                    formControlName="district"
                    nzPlaceHolder="Select District"
                  >
                    <nz-option nzValue="0" nzLabel="All"></nz-option>
                    @for (district of districts; track district) {
                    <nz-option
                      [nzValue]="district.dstrt_id"
                      [nzLabel]="district.dstrt_nm"
                    ></nz-option>
                    }
                  </nz-select>
                </nz-form-control>
              </nz-form-item>

              <!-- Circle Dropdown -->
              <nz-form-item>
                <nz-form-label [nzSpan]="5" nzFor="circle"
                  >Circle</nz-form-label
                >
                <nz-form-control [nzSpan]="18">
                  <nz-select
                    formControlName="circle"
                    nzPlaceHolder="Select Circle"
                    (nzFocus)="onCircleFocus()"
                  >
                    @if (circles?.length) {
                    <nz-option nzValue="0" nzLabel="All"></nz-option>
                    } @for (circle of circles; track circle) {
                    <nz-option
                      [nzValue]="circle.oms_crcle_id"
                      [nzLabel]="circle.oms_crcle_nm"
                    ></nz-option>
                    }
                  </nz-select>
                </nz-form-control>
              </nz-form-item>

              <!-- Division Dropdown -->
              <nz-form-item>
                <nz-form-label [nzSpan]="5" nzFor="division"
                  >Division</nz-form-label
                >
                <nz-form-control [nzSpan]="18">
                  <nz-select
                    formControlName="division"
                    nzPlaceHolder="Select Division"
                    (nzFocus)="onDivisionFocus()"
                  >
                    @if (divisions?.length) {
                    <nz-option nzValue="0" nzLabel="All"></nz-option>
                    } @for (division of divisions; track division) {
                    <nz-option
                      [nzValue]="division.oms_dvsn_id"
                      [nzLabel]="division.oms_dvsn_nm"
                    ></nz-option>
                    }
                  </nz-select>
                </nz-form-control>
              </nz-form-item>

              <!-- Ring Dropdown -->
              <nz-form-item>
                <nz-form-label [nzSpan]="5" nzFor="ring">Ring</nz-form-label>
                <nz-form-control [nzSpan]="18">
                  <nz-select
                    formControlName="ring"
                    nzPlaceHolder="Select Ring"
                    (nzFocus)="onRingFocus()"
                  >
                    @if (rings?.length) {
                    <nz-option nzValue="0" nzLabel="All"></nz-option>
                    } @for (ring of rings; track ring) {
                    <nz-option
                      [nzValue]="ring.oms_rng_id"
                      [nzLabel]="ring.oms_rng_nm"
                    ></nz-option>
                    }
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
              <!-- <button nz-button nzType="primary" nzSize="small" nzShape="round">
              <span nz-icon nzType="download"></span>
              get latlongs
            </button> -->

              <!-- Date Range Picker -->
              <!-- <nz-form-item>
            <nz-form-label [nzSpan]="5" nzFor="dateRange">Date Range</nz-form-label>
            <nz-form-control [nzSpan]="18">
              <nz-range-picker formControlName="dateRange"></nz-range-picker>
            </nz-form-control>
          </nz-form-item> -->
            </form>
          </div>
        </div>
      </div>
    </div>
  </nz-layout>
</div>
